<router-outlet *ngIf="propsLoaded && !loadError"></router-outlet>
<app-side-nav *ngIf="propsLoaded && !loadError && showSideNav$"></app-side-nav>
<app-pop-up *ngIf="propsLoaded && !loadError && popUp$"></app-pop-up>
<app-toast *ngIf="propsLoaded && !loadError"></app-toast>

<div *ngIf="!propsLoaded && !loadError" id="mainLoader">
    <div class="contentLoader mb-3"><span></span></div>
    <p>loading...</p>
</div>

<div *ngIf="loadError" class="netError">
    <ng-lottie class="lottie" [options]="lottieOptions" [styles]="lottieStyles"></ng-lottie>
    <h6>Connection Error</h6>
</div>